(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lk-blade-media-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lk-blade-room-slider')) {
    customElements.define('lk-blade-room-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.slides = Array.from(this.querySelectorAll('[data-room-slide]'));
        if (!this.slides.length) return;
        this.initialized = true;
        this.index = 0;
        this.querySelector('[data-room-controls]').hidden = this.slides.length < 2;
        this.show(0, false);
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-room-step]');
          if (button) this.show(this.index + Number(button.dataset.roomStep), true);
        });
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        });
      }
      show(index, animate) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => { slide.hidden = position !== this.index; });
        this.querySelector('[data-room-count]').textContent = (this.index + 1) + ' / ' + this.slides.length;
        const current = this.slides[this.index];
        if (animate && current.animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          current.getAnimations().forEach(animation => animation.cancel());
          current.animate([{ opacity: .35 }, { opacity: 1 }], { duration: 240, easing: 'ease-out' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-configurators-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lk-configurator-world')) {
  customElements.define('lk-configurator-world', class extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-cw-card]'));
      this.buttons = Array.from(this.querySelectorAll('[data-cw-filter]'));
      this.counter = this.querySelector('[data-cw-count]');
      this.discoverLink = this.querySelector('[data-cw-discover]');
      this.onDiscover = (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const selection = this.querySelector('.lk-cw__selection');
        if (!selection) return;
        event.preventDefault();
        selection.focus({ preventScroll: true });
        selection.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
          block: 'start'
        });
      };
      this.onFilter = (event) => {
        const button = event.target.closest('[data-cw-filter]');
        if (button && this.contains(button)) this.filter(button.dataset.cwFilter);
      };
      this.onBlockSelect = (event) => {
        if (event.target && this.contains(event.target)) this.filter('all');
      };
      this.addEventListener('click', this.onFilter);
      this.discoverLink?.addEventListener('click', this.onDiscover);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      const filters = this.querySelector('[data-cw-filters]');
      if (filters) filters.hidden = false;
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onFilter);
      this.discoverLink?.removeEventListener('click', this.onDiscover);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }
    filter(group) {
      let visible = 0;
      this.cards.forEach((card) => {
        card.hidden = group !== 'all' && card.dataset.cwGroup !== group;
        if (!card.hidden) visible += 1;
      });
      this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.cwFilter === group)));
      this.toggleAttribute('data-filtered', group !== 'all');
      if (this.counter) this.counter.textContent = this.dataset.countTemplate.replace('[count]', String(visible));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-home-autumn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lk-autumn-season')) {
    customElements.define('lk-autumn-season', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('[data-autumn-track]');
        this.previous = this.querySelector('[data-autumn-prev]');
        this.next = this.querySelector('[data-autumn-next]');
        if (!this.track) return;
        const move = direction => {
          const item = this.track.querySelector('.grid-item');
          const step = item?.getBoundingClientRect().width || this.track.clientWidth / 2;
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.track.scrollBy({ left: direction * step, behavior });
        };
        this.previous?.addEventListener('click', () => move(-1), options);
        this.next?.addEventListener('click', () => move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      update() {
        if (this.previous) this.previous.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-home-faq-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lk-home-faq-slider')) {
    customElements.define('lk-home-faq-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.slides = [...this.querySelectorAll('.lk-home-faq__slide')];
        if (!this.slides.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.lk-home-faq__track');
        this.viewport = this.querySelector('.lk-home-faq__viewport');
        this.counter = this.querySelector('.lk-home-faq__counter');
        this.toggle = this.querySelector('[data-toggle]');
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.focusable = new Map();
        this.slides.forEach(slide => slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(element => this.focusable.set(element, element.getAttribute('tabindex'))));
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.interval = Math.max(8000, Number(this.dataset.interval) || 10000);
        this.index = 0;
        this.inView = false;
        this.drag = null;
        this.focusInSlide = false;
        this.suppressClickUntil = 0;
        this.lastWheel = 0;
        this.wheelAmount = 0;
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify?.designMode);
        this.classList.add('is-ready');
        this.querySelector('.lk-home-faq__controls').hidden = this.slides.length < 2;
        this.querySelectorAll('[data-direction]').forEach(arrow => {
          arrow.hidden = this.slides.length < 2;
          arrow.addEventListener('click', () => this.navigate(Number(arrow.dataset.direction)), options);
        });
        this.show(0);
        this.updateToggle();
        this.dots.forEach(dot => dot.addEventListener('click', () => {
          this.goTo(Number(dot.dataset.dot));
        }, options));
        this.track.addEventListener('click', event => {
          if (performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          const slide = event.target.closest('.lk-home-faq__slide');
          if (!slide || Number(slide.dataset.index) === this.index) return;
          event.preventDefault();
          this.goTo(Number(slide.dataset.index));
        }, { ...options, capture: true });
        this.toggle.addEventListener('click', () => this.setPaused(!this.paused), options);
        this.viewport.addEventListener('pointerdown', event => this.startDrag(event), options);
        window.addEventListener('pointermove', event => this.moveDrag(event), options);
        window.addEventListener('pointerup', event => this.finishDrag(event), options);
        window.addEventListener('pointercancel', event => this.finishDrag(event, true), options);
        window.addEventListener('blur', () => this.finishDrag(null, true), options);
        this.viewport.addEventListener('dragstart', event => event.preventDefault(), options);
        this.viewport.addEventListener('wheel', event => {
          const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.shiftKey ? event.deltaY : 0;
          if (!delta) return;
          event.preventDefault();
          const now = performance.now();
          if (now - this.lastWheel < 550) return;
          this.wheelAmount += delta;
          if (Math.abs(this.wheelAmount) < 25) return;
          this.navigate(this.wheelAmount > 0 ? 1 : -1);
          this.wheelAmount = 0;
          this.lastWheel = now;
        }, { ...options, passive: false });
        this.addEventListener('focusin', event => {
          this.focusInSlide = Boolean(event.target.closest('.lk-home-faq__slide'));
          this.schedule();
        }, options);
        this.addEventListener('focusout', event => {
          this.focusInSlide = Boolean(event.relatedTarget && this.viewport.contains(event.relatedTarget));
          this.schedule();
        }, options);
        this.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          if (event.target.closest('input, textarea, select, [contenteditable]')) return;
          event.preventDefault();
          this.navigate(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.setPaused(true);
          this.show(index);
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) this.setPaused(true); }, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0.25 });
        this.observer.observe(this.viewport);
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, position) => {
          const inactive = position !== this.index;
          let offset = position - this.index;
          if (offset > this.slides.length / 2) offset -= this.slides.length;
          if (offset < -this.slides.length / 2) offset += this.slides.length;
          slide.style.setProperty('--lk-faq-offset', offset);
          slide.classList.toggle('is-active', !inactive);
          slide.classList.toggle('is-visible', Math.abs(offset) <= 1);
          slide.setAttribute('aria-hidden', String(inactive));
          slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(element => {
            const original = this.focusable.get(element);
            if (inactive) element.setAttribute('tabindex', '-1');
            else if (original === null) element.removeAttribute('tabindex');
            else element.setAttribute('tabindex', original);
          });
        });
        this.dots.forEach((dot, position) => dot.setAttribute('aria-current', String(position === this.index)));
        this.querySelector('[data-current]').textContent = String(this.index + 1);
      }
      navigate(direction) {
        this.goTo(this.index + direction);
      }
      goTo(index) {
        this.show(index);
        this.schedule();
      }
      startDrag(event) {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, moved: false };
        window.clearTimeout(this.timer);
      }
      moveDrag(event) {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const dx = event.clientX - this.drag.x;
        const dy = event.clientY - this.drag.y;
        if (!this.drag.moved) {
          if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy)) return;
          this.drag.moved = true;
          this.classList.add('is-dragging');
          this.viewport.setPointerCapture(event.pointerId);
        }
        if (event.cancelable) event.preventDefault();
        this.drag.dx = dx;
        const width = this.track.getBoundingClientRect().width;
        this.track.style.setProperty('--lk-faq-drag', `${Math.max(-width, Math.min(width, dx))}px`);
      }
      finishDrag(event, cancelled = false) {
        if (!this.drag || (event && event.pointerId !== this.drag.id)) return;
        const drag = this.drag;
        this.drag = null;
        this.classList.remove('is-dragging');
        this.track.style.removeProperty('--lk-faq-drag');
        if (this.viewport.hasPointerCapture(drag.id)) this.viewport.releasePointerCapture(drag.id);
        if (drag.moved) this.suppressClickUntil = performance.now() + 400;
        const threshold = Math.max(36, this.track.getBoundingClientRect().width * .15);
        if (!cancelled && drag.moved && Math.abs(drag.dx) >= threshold) this.navigate(drag.dx < 0 ? 1 : -1);
        else this.schedule();
      }
      updateToggle() {
        const label = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.toggle.setAttribute('aria-label', label);
        this.querySelector('[data-toggle-label]').textContent = label;
        this.counter.setAttribute('aria-live', this.paused ? 'polite' : 'off');
      }
      setPaused(paused) {
        this.paused = paused;
        this.updateToggle();
        this.schedule();
      }
      schedule() {
        window.clearTimeout(this.timer);
        if (this.paused || this.drag || this.focusInSlide || !this.inView || document.hidden || this.slides.length < 2) return;
        this.timer = window.setTimeout(() => {
          this.show(this.index + 1);
          this.schedule();
        }, this.interval);
      }
      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.focusable?.forEach((original, element) => {
          if (original === null) element.removeAttribute('tabindex');
          else element.setAttribute('tabindex', original);
        });
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lk-season-hero')) {
    customElements.define('lk-season-hero', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('[data-hero-track]');
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-hero-go]'));
        if (!this.track || !this.slides.length) return;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileQuery = window.matchMedia('(max-width: 768px)');
        this.mobile = this.mobileQuery.matches;
        this.panels = this.slides.flatMap(slide => [slide.querySelector('.lk-season-hero__brand'), slide.querySelector('.lk-season-hero__argument')]);
        this.frames = this.mobile ? this.panels : this.slides;
        this.paused = this.dataset.autoplay !== 'true' || this.reducedMotion.matches || Boolean(window.Shopify?.designMode);
        this.active = 0;
        this.hovered = false;
        this.focused = false;
        this.onScreen = true;
        this.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.go(this.active - 1), options);
        this.querySelector('[data-hero-next]')?.addEventListener('click', () => this.go(this.active + 1), options);
        this.dots.forEach(dot => dot.addEventListener('click', () => this.go(Number(dot.dataset.heroGo) * (this.mobile ? 2 : 1) + (this.mobile && dot.dataset.heroPanel === 'argument' ? 1 : 0)), options));
        this.querySelector('[data-hero-toggle]')?.addEventListener('click', () => { this.paused = !this.paused; this.updateTimer(); }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.update());
        }, { ...options, passive: true });
        this.track.addEventListener('mouseenter', () => { this.hovered = window.matchMedia('(hover: hover)').matches; this.updateTimer(); }, options);
        this.track.addEventListener('mouseleave', () => { this.hovered = false; this.updateTimer(); }, options);
        this.addEventListener('focusin', event => { this.focused = this.track.contains(event.target); this.updateTimer(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.track.contains(event.relatedTarget); this.updateTimer(); }, options);
        document.addEventListener('visibilitychange', () => this.updateTimer(), options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.paused = true; this.go(index * (this.mobile ? 2 : 1), true); }
        }, options);
        this.observer = new IntersectionObserver(entries => { this.onScreen = entries[0].isIntersecting; this.updateTimer(); });
        this.observer.observe(this);
        this.resizeObserver = new ResizeObserver(() => {
          if (this.mobile !== this.mobileQuery.matches) {
            this.active = this.mobileQuery.matches ? this.active * 2 : Math.floor(this.active / 2);
            this.mobile = this.mobileQuery.matches;
            this.frames = this.mobile ? this.panels : this.slides;
          }
          this.track.scrollTo({ left: this.active * this.track.clientWidth, behavior: 'instant' });
          this.update();
        });
        this.resizeObserver.observe(this.track);
        this.update();
        this.updateTimer();
      }
      go(index, instant = false) {
        const target = (index + this.frames.length) % this.frames.length;
        this.frames[target].inert = false;
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: instant || this.reducedMotion.matches ? 'instant' : 'smooth' });
        this.updateTimer();
      }
      update() {
        const width = this.track.clientWidth;
        if (!width) return;
        this.active = Math.max(0, Math.min(this.frames.length - 1, Math.round(this.track.scrollLeft / width)));
        this.dots.forEach(dot => {
          const index = Number(dot.dataset.heroGo) * (this.mobile ? 2 : 1) + (this.mobile && dot.dataset.heroPanel === 'argument' ? 1 : 0);
          dot.setAttribute('aria-current', String(index === this.active && (this.mobile || dot.dataset.heroPanel === 'brand')));
        });
        this.slides.forEach((slide, index) => { slide.inert = !this.mobile && index !== this.active; });
        this.panels.forEach((panel, index) => { panel.inert = this.mobile && index !== this.active; });
      }
      updateTimer() {
        clearInterval(this.timer);
        const toggle = this.querySelector('[data-hero-toggle]');
        if (toggle) {
          toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
          toggle.querySelector('[data-hero-play-icon]').textContent = this.paused ? '▷' : 'Ⅱ';
        }
        if (!this.paused && !this.hovered && !this.focused && this.onScreen && !document.hidden && this.frames.length > 1) {
          this.timer = setInterval(() => this.go(this.active + 1), Number(this.dataset.interval) || 5000);
        }
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        cancelAnimationFrame(this.scrollFrame);
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-home-lighting-types"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lk-home-types-more')) {
    customElements.define('lk-home-types-more', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.sequence = 0;
        this.button = this.querySelector('button');
        this.panel = this.querySelector('.lk-home-types__more-panel');
        this.inner = this.querySelector('.lk-home-types__more-inner');
        this.content = this.querySelector('[data-outdoor-content]');
        this.label = this.querySelector('[data-more-text]');
        if (!this.button || !this.panel || !this.inner || !this.content || !this.label) return;
        this.expanded = this.hasAttribute('data-expanded');
        this.button.hidden = false;
        this.button.addEventListener('pointerenter', () => this.prepareContent(), { once: true, signal: this.abort.signal });
        this.button.addEventListener('focus', () => this.prepareContent(), { once: true, signal: this.abort.signal });
        this.button.addEventListener('click', () => this.toggle(), { signal: this.abort.signal });
        window.addEventListener('resize', () => {
          this.animation?.cancel();
          this.animation = null;
        }, { signal: this.abort.signal });
      }
      prepareContent() {
        if (this.preparing) return this.preparing;
        const template = this.querySelector('[data-outdoor-template]');
        if (template) {
          this.content.append(template.content.cloneNode(true));
          template.remove();
        }
        this.preparing = Promise.all(Array.from(this.content.querySelectorAll('img'), image => {
          image.loading = 'eager';
          return image.decode ? image.decode().catch(() => {}) : Promise.resolve();
        })).then(() => { this.prepared = true; });
        return this.preparing;
      }
      async toggle() {
        const sequence = ++this.sequence;
        this.expanded = !this.expanded;
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.label.textContent = this.expanded ? this.button.dataset.lessLabel : this.button.dataset.moreLabel;
        if (this.expanded && !this.prepared) {
          let timer;
          await Promise.race([
            this.prepareContent(),
            new Promise(resolve => { timer = setTimeout(resolve, 160); })
          ]);
          clearTimeout(timer);
          if (sequence !== this.sequence || !this.isConnected) return;
        }
        const startHeight = this.panel.getBoundingClientRect().height;
        const startOpacity = getComputedStyle(this.panel).opacity;
        const fullHeight = this.inner.getBoundingClientRect().height;
        const endHeight = this.expanded ? fullHeight : 0;
        this.animation?.cancel();
        this.animation = null;
        this.toggleAttribute('data-expanded', this.expanded);
        this.panel.inert = !this.expanded;
        this.panel.setAttribute('aria-hidden', String(!this.expanded));
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || Math.abs(endHeight - startHeight) < 1) return;
        const animation = this.panel.animate([
          { height: startHeight + 'px', opacity: startOpacity, visibility: 'visible' },
          { height: endHeight + 'px', opacity: this.expanded ? 1 : 0, visibility: 'visible' }
        ], {
          duration: Math.max(120, (this.expanded ? 320 : 240) * Math.min(1, Math.abs(endHeight - startHeight) / Math.max(fullHeight, 1))),
          easing: 'cubic-bezier(0.25, 0.8, 0.25, 1)'
        });
        this.animation = animation;
        animation.onfinish = () => { if (this.animation === animation) this.animation = null; };
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.sequence += 1;
        this.animation?.cancel();
        this.animation = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lk-home-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lk-season-products')) {
    customElements.define('lk-season-products', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.visibility?.disconnect();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('[data-products-track]');
        this.previous = this.querySelector('[data-products-prev]');
        this.next = this.querySelector('[data-products-next]');
        this.feedback = this.querySelector('[data-products-feedback]');
        this.status = this.querySelector('[data-products-status]');
        this.lazy = this.hasAttribute('data-products-lazy');
        this.seen = new Set([...this.track?.querySelectorAll('[data-product-grid-item]') || []].map(item => item.dataset.productId));
        this.executed = new Set();
        if (!this.track) return;
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.querySelector('[data-products-retry]')?.addEventListener('click', () => { this.failed = false; this.loadNext(); }, options);
        this.track.addEventListener('scroll', () => {
          this.update();
          if (this.track.scrollLeft > (this.lastScrollLeft || 0)) this.loadNearEnd();
          this.lastScrollLeft = this.track.scrollLeft;
        }, { ...options, passive: true });
        this.track.addEventListener('wheel', event => {
          if (event.deltaX > 2 || (event.shiftKey && event.deltaY > 2)) this.loadNearEnd();
        }, { ...options, passive: true });
        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse') this.swipeStart = { x: event.clientX, y: event.clientY };
        }, { ...options, passive: true });
        this.track.addEventListener('pointermove', event => {
          if (!this.swipeStart) return;
          const distance = this.swipeStart.x - event.clientX;
          if (distance > 24 && distance > Math.abs(this.swipeStart.y - event.clientY) * 1.25) this.loadNearEnd();
        }, { ...options, passive: true });
        for (const event of ['pointerup', 'pointercancel']) this.track.addEventListener(event, () => { this.swipeStart = null; }, options);
        this.observer = new ResizeObserver(() => {
          const width = this.track.querySelector('.grid-item')?.getBoundingClientRect().width;
          if (width && this.cardWidth && width !== this.cardWidth && window.matchMedia('(max-width: 768px)').matches) {
            const index = this.cardIndex || 0;
            this.track.scrollTo({ left: index * width, behavior: 'instant' });
          }
          this.cardWidth = width;
          this.update();
        });
        this.observer.observe(this.track);
        if (this.lazy && !this.started) {
          if ('IntersectionObserver' in window) {
            this.visibility = new IntersectionObserver(entries => {
              if (entries.some(entry => entry.isIntersecting)) {
                this.visibility.disconnect();
                this.start();
              }
            }, { threshold: 0.01 });
            this.visibility.observe(this.track);
          } else this.start();
        }
        this.update();
      }
      async start() {
        if (this.started) return;
        this.started = true;
        this.priming = true;
        const page = this.querySelector('template[data-products-page]');
        if (page) { this.appendPage(page); page.remove(); }
        this.priming = false;
        this.update();
      }
      appendPage(page) {
        const fragment = page.content.cloneNode(true);
        fragment.querySelectorAll('.grid-item').forEach(card => {
          const id = card.querySelector('[data-product-grid-item]')?.dataset.productId;
          if (!id || this.seen.has(id)) card.remove();
          else this.seen.add(id);
        });
        fragment.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; });
        fragment.querySelectorAll('[defer-hydration]').forEach(element => element.removeAttribute('defer-hydration'));
        const scripts = [...fragment.querySelectorAll('script')].filter(script => !script.type || script.type === 'module' || script.type === 'text/javascript');
        scripts.forEach(script => script.remove());
        this.track.querySelectorAll('.lk-home-products__placeholder').forEach(element => element.remove());
        this.track.append(fragment);
        for (const source of scripts) {
          const key = source.src || source.textContent;
          if (this.executed.has(key)) continue;
          this.executed.add(key);
          const script = document.createElement('script');
          [...source.attributes].forEach(attribute => script.setAttribute(attribute.name, attribute.value));
          script.textContent = source.textContent;
          this.track.append(script);
        }
        this.nextUrl = page.dataset.nextUrl || '';
        this.dataset.productsLoaded = String(this.seen.size);
        this.update();
      }
      async loadNext() {
        if (!this.nextUrl || this.busy || !this.isConnected) return;
        this.busy = true;
        this.failed = false;
        this.track.setAttribute('aria-busy', 'true');
        if (this.feedback) this.feedback.hidden = true;
        if (this.status) this.status.textContent = this.status.dataset.loading;
        this.update();
        const controller = new AbortController();
        this.request = controller;
        const timer = setTimeout(() => controller.abort(), 15000);
        try {
          const url = new URL(this.nextUrl, location.href);
          if (url.origin !== location.origin) throw new Error('Invalid product page');
          url.searchParams.set('section_id', this.dataset.productsSection);
          if (this.dataset.productsTheme) url.searchParams.set('preview_theme_id', this.dataset.productsTheme);
          const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw new Error('Products unavailable');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const page = document.querySelector('template[data-products-page]');
          if (!page || !page.content.querySelector('[data-product-grid-item]')) throw new Error('Invalid product response');
          if (this.isConnected) this.appendPage(page);
          if (this.status) this.status.textContent = '';
        } catch (error) {
          if (this.isConnected) {
            this.failed = true;
            if (this.feedback) this.feedback.hidden = false;
            if (this.status) this.status.textContent = this.status.dataset.error;
          }
        } finally {
          clearTimeout(timer);
          this.busy = false;
          this.track.removeAttribute('aria-busy');
          this.update();
        }
      }
      loadNearEnd() {
        if (!this.lazy || !this.started || this.priming || this.failed || this.busy || !this.nextUrl) return;
        const item = this.track.querySelector('.grid-item');
        const buffer = (item?.getBoundingClientRect().width || this.track.clientWidth / 2) * 0.5;
        if (this.track.scrollWidth - this.track.clientWidth - Math.abs(this.track.scrollLeft) <= buffer) this.loadNext();
      }
      async move(direction) {
        if (direction > 0 && this.lazy && !this.started) await this.start();
        if (direction > 0 && this.nextUrl && this.track.scrollWidth - this.track.clientWidth - Math.abs(this.track.scrollLeft) <= 2) await this.loadNext();
        const item = this.track.querySelector('.grid-item');
        const step = item?.getBoundingClientRect().width || this.track.clientWidth / 2;
        this.track.scrollBy({ left: direction * step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const width = this.track.querySelector('.grid-item')?.getBoundingClientRect().width;
        if (width && width === this.cardWidth) this.cardIndex = Math.round(this.track.scrollLeft / width);
        const atEnd = Math.abs(this.track.scrollLeft) >= this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.previous) this.previous.disabled = Math.abs(this.track.scrollLeft) <= 2;
        if (this.next) this.next.disabled = atEnd && (!this.nextUrl || this.busy) && (!this.lazy || this.started);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.visibility?.disconnect();
        this.request?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();
})();
